module.exports = __webpack_public_path__ + "static/media/crystallure_brand_banner.33fc62ec.jpg";